import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  header: css`
    display: flex;
    flex-direction: column;
    padding: 14px 12px;
    gap: 16px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
